import type { ReactNode } from "react";

interface GlassCardProps {
  title?: ReactNode;
  hint?: ReactNode;
  action?: ReactNode;
  pad?: "default" | "sm";
  className?: string;
  children: ReactNode;
}

/** Unified frosted card base (web/design.md §6 GlassCard). */
export function GlassCard({
  title,
  hint,
  action,
  pad = "default",
  className = "",
  children,
}: GlassCardProps) {
  const showHead = title || hint || action;
  return (
    <section className={`glass ${pad === "sm" ? "glass--pad-sm" : ""} ${className}`}>
      {showHead && (
        <header className="glass__head">
          <div>
            {title && <div className="glass__title">{title}</div>}
            {hint && <div className="glass__hint">{hint}</div>}
          </div>
          {action}
        </header>
      )}
      {children}
    </section>
  );
}
